import i from "clsx";
import t from "react";
import { s as r } from "../../../../../RideGlyph.module-CgKw9y7i.mjs";
function c({
  size: e = "small",
  accessibilityTitle: C = "glyph information solid",
  className: l,
  "data-testid": o,
  fill: a,
  stroke: n
}) {
  const s = () => i(l, r["ride-glyph"], {
    [r[`size-${e}`]]: e
  });
  return /* @__PURE__ */ t.createElement("div", { className: s(), "data-testid": o }, /* @__PURE__ */ t.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: a || "#03050F",
      stroke: n || "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    C && /* @__PURE__ */ t.createElement("title", null, C),
    /* @__PURE__ */ t.createElement("path", { d: "M16.0026 3.99805C13.6294 3.99805 11.3094 4.7018 9.33614 6.0203C7.36285 7.3388 5.82487 9.21285 4.91667 11.4054C4.00847 13.598 3.77084 16.0107 4.23383 18.3383C4.69683 20.666 5.83966 22.8041 7.5178 24.4822C9.19594 26.1603 11.334 27.3032 13.6617 27.7662C15.9893 28.2292 18.402 27.9915 20.5946 27.0833C22.7872 26.1751 24.6612 24.6371 25.9797 22.6639C27.2982 20.6906 28.002 18.3706 28.002 15.9974C27.9992 12.8158 26.734 9.76536 24.4843 7.51566C22.2346 5.26595 19.1842 4.00084 16.0026 3.99805ZM16.0026 8.99821C16.3001 8.99821 16.591 9.08651 16.8383 9.25192C17.0856 9.41733 17.2783 9.65241 17.3919 9.9274C17.5055 10.2024 17.535 10.5049 17.4765 10.7966C17.4181 11.0884 17.2744 11.3562 17.0637 11.5662C16.8529 11.7762 16.5846 11.919 16.2926 11.9764C16.0007 12.0338 15.6983 12.0033 15.4237 11.8887C15.1491 11.7741 14.9147 11.5806 14.7502 11.3327C14.5856 11.0848 14.4984 10.7937 14.4994 10.4962C14.4994 10.299 14.5383 10.1038 14.6139 9.92169C14.6895 9.73961 14.8003 9.57424 14.94 9.43508C15.0797 9.29591 15.2454 9.18569 15.4278 9.11072C15.6101 9.03575 15.8055 8.99752 16.0026 8.99821V8.99821ZM18.9985 21.9997H14.0036V19.9954H15.5015V14.9952H14.0036V12.9962H17.5005V19.9954H18.9985V21.9997Z" })
  ));
}
export {
  c as RideGlInformationSolid
};
